import {
  groupBy,
  sortArrayOfObjects,
} from "../../../../utility/common-methods";

function getSum(total, num) {
  try {
    return parseInt(total, 10) + parseInt(num, 10);
  } catch (e) {
    return 0;
  }
}

export const formatSocialWordCloudData = (d) => {
  try {
    const dataByReportType = d.graph_data;
    let temp = [];
    dataByReportType &&
      Object.keys(dataByReportType).map((e) => {
        if (dataByReportType[e].data) {
          temp.push(dataByReportType[e].data.map((el) => el).flat());
        }
      });
    temp = temp.flat();
    const uniqueKeywords = groupBy(temp, "keyword") || {};
    const data = Object.keys(uniqueKeywords).map((kw) => {
      const listOfKWCount = uniqueKeywords[kw].map((elm) => elm.count);
      const totalOfSimilarKW = listOfKWCount.reduce(getSum, 0);
      return {
        name: kw,
        weight: +totalOfSimilarKW,
      };
    });
    const top25Words = sortArrayOfObjects(data, "weight", false) || [];
    return top25Words.slice(0, 25);
  } catch (e) {
    return {
      text: "",
      value: "",
    };
  }
};
